import { useMutation, useQueryClient } from "@tanstack/react-query";
import React, { useState } from "react";
import ApproveModal from "../../../../../components/element/ApproveModal";
import CorrectionNeededAccountDialog from "../../../../../components/element/CorrectionNeededAccountDialog";
import Modal from "../../../../../components/element/Modal";
import RejectModal from "../../../../../components/element/RejectModal";
import SnackbarAlert from "../../../../../components/element/SnackbarAlert";
import SuccessModal from "../../../../../components/element/SuccessModal";
import useAirlineAdminApi from "../../../../../services/api/useAirlineAdminApi";
import {
  ClearanceStatus as Status,
  TRIP_PHASE,
} from "../../../../../utils/constants";
import "../css/EscortArrivalActionButtons.css";
import { useFormData } from "../../../../../helpers/FormDataProvider";

const EscortArrivalActionButtons = ({
  flightPlanId,
  officers,
  clearanceStatus: initialClearanceStatus,
}) => {
  const { userData } = useFormData();
  const queryClient = useQueryClient();
  const { approveEscortService, rejectEscort } = useAirlineAdminApi(
    userData.isAAUser
  );

  const [clearanceStatus, setClearanceStatus] = useState(
    initialClearanceStatus
  );
  const arrivalData = {
    escortOfficers: officers,
    cfpPhase: TRIP_PHASE.ARRIVAL,
  };

  const [modalState, setModalState] = useState({
    isApproveModalOpen: false,
    isRejectModalOpen: false,
    isCorrectionNeedModalOpen: false,
  });
  const [selectedReason, setSelectedReason] = useState("");
  const [correctionReason, setCorrectionReason] = useState("");
  const [commonError, setCommonError] = useState(null);

  const [successModalData, setSuccessModalData] = useState({
    isOpen: false,
    title: "",
    message: "",
  });

  const closeSuccessModal = () => {
    setSuccessModalData({
      isOpen: false,
      title: "",
      message: "",
    });
  };
  //TODO: all comments will be removed once api integrate

  const { mutate: approveEscortMutate, isPending: isApprovePending } =
    useMutation({
      mutationFn: ({ flightPlanId, data }) =>
        approveEscortService(flightPlanId, data),
      onSuccess: () => {
        setClearanceStatus(Status.CLEARANCE_GRANTED || Status.PAID);
        setSuccessModalData({
          isOpen: true,
          title: "Approved",
          message:
            "You have successfully approved the Special Onboarding Request",
        });
        closeModal("isApproveModalOpen");
      },
      onError: (error) => {
        setCommonError(error.message);
        closeModal("isApproveModalOpen");
      },
    });

  const { mutate: rejectEscortMutate, isPending: isRejectPending } =
    useMutation({
      mutationFn: ({ flightPlanId, data }) => rejectEscort(flightPlanId, data),
      onSuccess: () => {
        setClearanceStatus(Status.CLEARANCE_REJECTED);
        setSuccessModalData({
          isOpen: true,
          title: "Rejected",
          message: "The request was rejected for this Flight Plan",
        });
        queryClient.invalidateQueries({ queryKey: ["specialOnboarding"] });
        closeModal("isRejectModalOpen");
      },
      onError: (error) => {
        setCommonError(error.message);
        closeModal("isRejectModalOpen");
      },
    });

  // const {
  //   mutate: correctionNeededEscortMutate,
  //   isPending: isCorrectionPending,
  // } = useMutation({
  //   mutationFn: ({ flightNumber, data }) => correctionNeededEscort(flightNumber, data),
  //   onSuccess: () => {
  //     setClearanceStatus(Status.CORRECTION_REQUESTED);
  //     setSuccessModalData({
  //       isOpen: true,
  //       title: "Correction Needed",
  //       message: "Correction is requested for this Trip",
  //     });
  //     closeModal("isCorrectionNeedModalOpen");
  //   },
  //   onError: (error) => {
  //     setCommonError(error.message);
  //     closeModal("isCorrectionNeedModalOpen");
  //   },
  // });

  const openModal = (modalName) => {
    if (modalName === "isApproveModalOpen") {
      if (officers.length < 2) {
        setCommonError("At least 2 officers must be added before approving");
        setTimeout(() => setCommonError(null), 3000);
        return;
      }

      // Check for duplicate officers
      const uniqueOfficerIds = new Set(
        officers.map((officer) => officer.officerId)
      );
      if (uniqueOfficerIds.size !== officers.length) {
        setCommonError("Cannot have duplicate officers");
        setTimeout(() => setCommonError(null), 3000);
        return;
      }
    }

    setModalState({
      isApproveModalOpen: false,
      isRejectModalOpen: false,
      isCorrectionNeedModalOpen: false,
      [modalName]: true,
    });
    setCommonError(null);
  };

  const closeModal = (modalName) => {
    setModalState((prevState) => ({
      ...prevState,
      [modalName]: false,
    }));
  };

  const handleCorrectNeeded = (event) => {
    event.preventDefault();
    // correctionNeededEscortMutate({
    //   flightNumber,
    //   data: { correctionReason, tripPhase: TRIP_PHASE.ARRIVAL },
    // });
  };

  const handleApproveEscort = () => {
    approveEscortMutate({
      flightPlanId: flightPlanId,
      data: arrivalData,
    });
  };

  const handleRejectEscort = (e) => {
    e.preventDefault();
    rejectEscortMutate({
      flightPlanId,
      data: { rejectionReason: selectedReason, cfpPhase: TRIP_PHASE.ARRIVAL },
    });
  };

  const getButtonProps = (type) => {
    if (type === "approve") {
      return {
        text: isApproved ? "Approved" : "Approve",
        className: `escort-arrival-trip-details-btn ${
          isApproved
            ? "escort-arrival-trip-details-approve-btn-approved not-clickable"
            : "escort-arrival-trip-details-approve-btn"
        }`,
        onClick: isApproved ? null : () => openModal("isApproveModalOpen"),
        disabled: allDisabled && !isApproved,
      };
    } else if (type === "reject") {
      return {
        text: isRejected ? "Rejected" : "Reject",

        className: `escort-arrival-trip-details-btn ${
          isRejected
            ? "rejected not-clickable"
            : "escort-arrival-trip-details-reject-btn"
        }`,
        onClick: isRejected ? null : () => openModal("isRejectModalOpen"),
        disabled: allDisabled && !isRejected,
      };
    }
    // else if (type === "correction") {
    //   return {
    //     text: "Correction Needed",
    //     className: "escort-arrival-trip-details-correction-btn",
    //     onClick: () => openModal("isCorrectionNeedModalOpen"),
    //     disabled: allDisabled,
    //   };
    // }
    return {};
  };

  const isApproved =
    clearanceStatus === Status.CLEARANCE_GRANTED ||
    clearanceStatus === Status.PAID;
  const isRejected = clearanceStatus === Status.CLEARANCE_REJECTED;
  const allDisabled = isApproved || isRejected;

  return (
    <div>
      {commonError && (
        <SnackbarAlert type={"error"}>{commonError}</SnackbarAlert>
      )}

      <div className="escort-arrival-trip-details-action-buttons">
        <div className="escort-arrival-action-buttons-row">
          <button {...getButtonProps("approve")}>
            {getButtonProps("approve").text}
          </button>
          <button {...getButtonProps("reject")}>
            {getButtonProps("reject").text}
          </button>
        </div>
        {/* <button {...getButtonProps("correction")}>
          {getButtonProps("correction").text}
        </button> */}
      </div>

      <Modal
        isOpen={modalState.isRejectModalOpen}
        onClose={() => closeModal("isRejectModalOpen")}
      >
        <RejectModal
          selectedReason={selectedReason}
          onReasonChange={(e) => setSelectedReason(e.target.value)}
          isLoading={isRejectPending}
          onRejectClick={handleRejectEscort}
        />
      </Modal>
      <CorrectionNeededAccountDialog
        open={modalState.isCorrectionNeedModalOpen}
        onClose={() => closeModal("isCorrectionNeedModalOpen")}
        onSave={(e) => setCorrectionReason(e.target.value)}
        isLoading={false}
      />

      <Modal
        isOpen={modalState.isApproveModalOpen}
        onClose={() => closeModal("isApproveModalOpen")}
      >
        <ApproveModal
          onApprove={handleApproveEscort}
          isLoading={isApprovePending}
          message={"Do you want to approve the Special Onboarding Request?"}
        />
      </Modal>
      <SuccessModal
        isOpen={successModalData.isOpen}
        onClose={closeSuccessModal}
        title={successModalData.title}
        message={successModalData.message}
        buttonLabel="OK"
      />
    </div>
  );
};

export default EscortArrivalActionButtons;
